import {throttle} from "lodash-es";

ready().then(function() {

    // based on page template
    if($('body').hasClass('single-wpg_book')) {
        // yes, i know, very specific

        /**
         * Change the mobile layout -
         * this is needed to avoid double copying html imgs and sections and displaying them to none. It's also unfortunately
         * not possible with css grid since these elements live in another column (if we remove the colums it get messed up by row-heigts)
         */
        // ***************** See VER-10000 *****************
        // Commented out for now - since we changed the html structure of the section-book-info.twig variant-3
        // See https://bitbucket.org/weekbladpersgroep/website-platform-multisite/src/0eb0aaa2952207c7dde37967974b7899f76cd99f/public/wp-content/plugins/wpg-boekenplatform/src/templates/components/sections/section-book-info.twig#lines-209:238
        // ***************** See VER-10000 *****************
        //
        // const changeMobileLayout = () => {
        //     let coverholder = $('.col-cover-holder');
        //     let coverimg = $('.col-cover-holder .tab-content-img-container');
        //     let colinfo = $('.col-info-container');

        //     // do something when are or becoming mobile
        //     const reorderCoverImgMobileView = () => {
        //         if(coverimg.length > 0) {
        //             colinfo.prepend(coverimg);
        //         }
        //     }
        //     // do something when are or becoming desktop
        //     const reorderCoverImgDesktopView = () => {
        //         if(coverimg.length > 0) {
        //             coverholder.prepend(coverimg);
        //         }
        //     }

        //     // set the media breakpoint - these vars (sizes) exist already in our global variables
        //     let mediaBreakPoint = window.matchMedia('(max-width:' + maxSm + 'px)');

        //     // Handle Media Query if it matches the breakpoint
        //     const handleMediaQuery = () => {
        //         if (mediaBreakPoint.matches === true ) {
        //             return reorderCoverImgMobileView();
        //         } else {
        //             return reorderCoverImgDesktopView();
        //         }
        //     }

        //     // run by default
        //     handleMediaQuery();
        //     // and on media size change
        //     mediaBreakPoint.addEventListener('change', () => {
        //         handleMediaQuery();
        //     });
        // }

        // changeMobileLayout();

        /**
         * Also - very specifically we need to check if the order-btns are still in the viewport or not and then fire some action the the floating and product order badge
         * If this becomes standard - we can use this function in the generic plugin
         */
        const checkOrderBtnInViewport = () => {
            let orderBtns = $(".order-buttons-container");
            let productOrderBadge = $(".product-order-badge-container");
            let header = $("header");

            let offSetPosOrderBtn = orderBtns.offset().top;
            let offSetHeader = header.offset().top;

            if (offSetPosOrderBtn > offSetHeader + 130) {
                productOrderBadge.addClass("is-vishidden");
            } else {
                productOrderBadge.removeClass("is-vishidden");
            }
        };

        // run by default
        checkOrderBtnInViewport();

        // but also check scroll events, but not all the time please
        window.addEventListener(
            "scroll",
            throttle(() => {
                // this throttle (utility) method is done so the event handler is not executed on each event, but once a 200ms
                checkOrderBtnInViewport();
            }, 200)
        );
    }

});
